import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { getCashbotButtonAttrs } from '../utils/cashbotUtils';
import { PAYMENT_METHODS, processPayment } from '../payment/paymentModule';

import { getPaypalPaymentRequest } from './paypalSelectors';
import { getPaypalLoaded } from './paypalModule';
import {
    getShippingTotal,
    getSubTotal
} from '../item/itemSelectors';
import { getDiscountRewardAmount } from '../promo/promoSelectors';
import { logError } from '../utils/errorUtils';
import { getGrandTotal } from '../payment/paymentSelectors';







export const PaypalButton = ({
    handleSubmit,
    isDisabled
}) => {
    const [prevTotal, setPrevTotal] = useState('0');
    const [paypalActive, setPaypalActive] = useState(false);
    const [paypalActions, setPaypalActions] = useState({});
    const [paypalButton, setPaypalButton] = useState(null);

    
    const paypalLoaded = useSelector(getPaypalLoaded);
    const payment = useSelector(getPaypalPaymentRequest);
    const subtotal = useSelector(getSubTotal);
    const shippingTotal = useSelector(getShippingTotal);
    const discount = useSelector(getDiscountRewardAmount);
    const total = useSelector(getGrandTotal);
    const handlingTotal = useSelector(state => state.getIn(['paypal', 'paypalHandlingTotal']));
    const dispatch = useDispatch();

    
    const paymentHandler = (data, actions) => {
        if (total < 1) {
            logError('Amount to be sent to PayPal for pre-auth is less than $1.',
                {
                    payment,
                    total,
                    subtotal,
                    shippingTotal,
                    handlingTotal,
                    discount
                });
        }
        return actions.order.create(payment);
    };

    
    const authHandler = (data, actions) => dispatch(
        processPayment(PAYMENT_METHODS.paypal, actions.order.authorize)
    );

    const initHandler = (data, actions) => {
        
        actions.disable();

        
        setPaypalActions(actions);
    };

    const renderPaypal = () => {
        if (paypalButton) {
            paypalButton.close();
        }
        const button = window.paypal.Buttons({
            onInit: initHandler,
            onClick: handleSubmit(() => {}), 
            createOrder: paymentHandler,
            onApprove: authHandler,
            style: {
                layout: 'horizontal',
                color: 'white',
                tagline: false
            }
        });
        button.render('#paypal-button-container');
        setPaypalButton(button);
    };

    const buttonProps = {
        className: 'paypal-container',
        ...getCashbotButtonAttrs('pay-with-paypal', 'button')
    };

    useEffect(() => {
        if (paypalLoaded && (!paypalActive || !total.eq(prevTotal))) {
            setPrevTotal(total);
            renderPaypal();
            setPaypalActive(true);
        }

        const { disable, enable } = paypalActions;

        
        if (isDisabled && disable) {
            disable();
        } else if (enable) {
            enable();
        }
    }, [total, paypalLoaded, isDisabled, paypalActions]);

    if (!paypalLoaded) {
        return null;
    }

    return (
        <div {...buttonProps} data-testid="paypal-button">
            <div id="paypal-button-container" />
        </div>
    );
};

PaypalButton.defaultProps = {
    isDisabled: false
};

PaypalButton.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool
};

export default PaypalButton;
